export default __webpack_public_path__ + "images/ST.22c799d.png";